module.exports = __webpack_public_path__ + "static/season-sponsors-2020-bf4f8d9208edfe04ced691354f72cfff.png";